import { useParams } from 'react-router-dom';
import { useGetcomplainUserAppQuery } from './complainUserAppSlice';
import { useGetWardsQuery } from '../Cleaner/CleanerSlice';

const ComplainUserAppDetail = () => {
    const { id } = useParams();

    const {
        data: Wards
    } = useGetWardsQuery("getWards");

    const {
        data: complainUserApp
    } = useGetcomplainUserAppQuery();

    return (
        <>
            <div className='container-fluid p-4'>
                <div className='row d-flex justify-content-between m-3'>
                    <h4 className='col-5'>
                        Complain User App
                    </h4>
                </div>
                {complainUserApp?.entities?.undefined?.map((e) =>
                    id == e?.id ? (
                        <div key={e?.c_id} className='row card card-body p-3'  >
                            <p className='col-12'><b>Name :</b> <span>{e?.u_name}</span></p>
                            <p className='col-12'><b>Number :</b> <span>{e?.u_number}</span></p>
                            <p className='col-12'><b>Added :</b> <span>{e?.added_by}</span></p>
                            <p className='col-12'><b>complain :</b> <span>{e?.complain_text}</span></p>
                            <p className='col-12'><b>Added :</b> <span>{e?.added_by}</span></p>

                            <p className='col-12'>
                                <b>Date :</b>
                                <span>
                                    {new Date(e?.created_at).toLocaleString("en-IN", {
                                        timeZone: "Asia/Kolkata",
                                        day: "2-digit",
                                        month: "long",
                                        year: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        second: "2-digit",
                                        hour12: true,
                                    })}
                                </span>
                            </p>
                            <p className='col-12'><b>Address :</b> <span>{e?.full_address}</span></p>
                            <p className='col-12'><b>House Number :</b> <span>{e?.house_number}</span></p>
                            <p className='col-12'><b>property :</b> <span>{e?.property_type}</span></p>
                            <p className='col-12'><b>property Id :</b> <span>{e?.prp_id}</span></p>
                            <p className='col-12'><b>street :</b> <span>{e?.street}</span></p>
                            {/* <p className='col-12'><b>street :</b> <span>{e?.image_url}</span></p> */}
                            <p className='col-12'><b>Image :</b> <span><img src={e?.image_url} /></span></p>
                            {/* <p className='col-12'><b>street :</b> <span><img src={require(e?.image_url)}/></span></p> */}
                            <p className='col-12'><b>ward:</b>
                                {
                                    Wards?.ids.map((item) => {
                                        return item == e?.ward_id ? <span>{Wards?.entities[item]?.ward_number}</span> : ""
                                    })
                                }
                            </p>
                        </div>
                    ) : null
                )
                }
            </div>
        </>
    );
}

export default ComplainUserAppDetail;
